// Auth component in pages/auth/withAuth.jsx
import React, { useEffect, useState } from "react";
import { useRouter } from 'next/router';
import { usePathname } from "next/navigation";
import { ROLES, ROUTE_STRING, STATUS } from "@/utils/constant";
import { getCurrentDateTimeApi } from "@/components/action/easycampus";
import moment from "moment";
import { showToast } from "@/utils/showtoast";
import routes from "@/utils/routes";
import NotFoundPage from "../404";
// import { useStateValue } from "@/components/common/context/statecontext";

const Auth = (props) => {
    const router = useRouter();
    const { children } = props;
    const currentRoute = usePathname("");
    // const { setData } = useStateValue();
    const lastSegment = currentRoute?.split("/").pop();
    const [isDateTimeValidate, setIsDateTimeValidate] = useState(false);
    const [previousUrl, setPreviousUrl] = useState("");
    const [isNotFound, setIsNotFound] = useState(false);


    // console.log("currentRoute",currentRoute);
    // console.log("lastSegment",lastSegment);


    useEffect(() => {

        let storePrevousRedirectUrl = sessionStorage.setItem("previousUrl", currentRoute);
        const AllAuthentical = sessionStorage.getItem("isAllAuthentical")
        const tokenData = sessionStorage.getItem("loginData");
        const loginData = tokenData ? JSON.parse(tokenData) : null;

        if (!loginData) {
            router.push("/");
            return;
        }

        const userRole = loginData?.data?.userType;
        let previousUrl = sessionStorage.getItem("previousUrl");
        setPreviousUrl(sessionStorage.getItem("previousUrl"));
        // console.log("previousUrl login", previousUrl);
        // console.log("previousUrl currentRoute", currentRoute);

        // Determine route access
        if (currentRoute || previousUrl) {
            const isRouteAuthorized = Object.entries(routes).some(([category, paths]) => {
                return (
                    Object.keys(paths).includes(currentRoute) &&
                    paths[currentRoute].includes(userRole)
                );
            });

            // console.log("isRouteAuthorized",isRouteAuthorized);
            // console.log("currentRoute ",currentRoute);

            if (!isRouteAuthorized) {
                setIsNotFound(true);
                return;
            }
        }
        if (!loginData) {
            router.push("/"); // Redirect to login if no token
            return;
        } else {
            // console.log("AllAuthentical",AllAuthentical);
            
            if (!AllAuthentical && loginData.data.isProfileUpdated && loginData.data.isPaymentStatus && loginData.data.isRenewStatus && loginData.data.isReveiwStatus === STATUS.APPROVED && loginData.data.isInitialReveiwStatus === STATUS.APPROVED) {
                if (loginData.data.userType === ROLES.INTERVIEWER) {
                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.APPROVED &&
                        loginData.data.isPaymentStatus === true &&
                        loginData.data.isRenewStatus === true &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true
                    ) {
                        sessionStorage.setItem("isAllAuthentical", true);
                        getCurrentDateTime();
                        if (currentRoute) {
                            router.push(currentRoute);
                        } else {
                            router.push(`/${ROUTE_STRING.DASHBOARD}`);
                        }
                        // router.push(`/${ROUTE_STRING.DASHBOARD}`);
                    }
                }
                if (loginData.data.userType === ROLES.CAMPUS) {
                    if (
                        loginData.data.isProfileUpdated === false &&
                        loginData.data.isReveiwStatus === STATUS.INITIAL &&
                        loginData.data.isPaymentStatus === false &&
                        loginData.data.isRenewStatus === false &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UPDATE_CAMPUS}`);
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.PENDING &&
                        loginData.data.isPaymentStatus === false &&
                        loginData.data.isRenewStatus === false &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UPDATE_CAMPUS}`);
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.PENDING &&
                        loginData.data.isPaymentStatus === true &&
                        loginData.data.isRenewStatus === true
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
                    }
                    if (
                        loginData.data.isReveiwStatus === STATUS.INITIAL &&
                        loginData.data.isInitialReveiwStatus === STATUS.PENDING
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
                    }
                    if (
                        loginData.data.isRenewStatus === false &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true &&
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.APPROVED &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UPDATE_CAMPUS}`);
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true &&
                        loginData.data.isReveiwStatus === STATUS.REJECTED &&
                        loginData.data.isPaymentStatus === true &&
                        loginData.data.isRenewStatus === true &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UPDATE_CAMPUS}`);
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.APPROVED &&
                        loginData.data.isPaymentStatus === true &&
                        loginData.data.isRenewStatus === true &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true
                    ) {
                        sessionStorage.setItem("isAllAuthentical", true);
                        getCurrentDateTime();
                        // router.push(`/${ROUTE_STRING.DASHBOARD}`);
                        if (currentRoute) {
                            router.push(currentRoute);
                        } else {
                            router.push(`/${ROUTE_STRING.DASHBOARD}`);
                        }
                    }
                }

                if (loginData.data.userType === ROLES.CORPORATE) {
                    if (
                        loginData.data.isProfileUpdated === false &&
                        loginData.data.isReveiwStatus === STATUS.INITIAL &&
                        loginData.data.isPaymentStatus === false &&
                        loginData.data.isRenewStatus === false &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push("/corporates/corporateprofileupdate");
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.PENDING &&
                        loginData.data.isPaymentStatus === false &&
                        loginData.data.isRenewStatus === false &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push("/corporates/corporateprofileupdate");
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.PENDING &&
                        loginData.data.isPaymentStatus === true &&
                        loginData.data.isRenewStatus === true
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
                    }
                    if (
                        loginData.data.isReveiwStatus === STATUS.INITIAL &&
                        loginData.data.isInitialReveiwStatus === STATUS.PENDING
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
                    }
                    if (
                        loginData.data.isRenewStatus === false &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true &&
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.APPROVED &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push("/corporates/corporateprofileupdate");
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true &&
                        loginData.data.isReveiwStatus === STATUS.REJECTED &&
                        loginData.data.isPaymentStatus === true &&
                        loginData.data.isRenewStatus === true &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push("/corporates/corporateprofileupdate");
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.APPROVED &&
                        loginData.data.isPaymentStatus === true &&
                        loginData.data.isRenewStatus === true &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true
                    ) {
                        sessionStorage.setItem("isAllAuthentical", true);
                        getCurrentDateTime();
                        // router.push(`/${ROUTE_STRING.DASHBOARD}`);
                        if (currentRoute) {
                            router.push(currentRoute);
                        } else {
                            router.push(`/${ROUTE_STRING.DASHBOARD}`);
                        }
                    }
                }

                if (loginData.data.userType === ROLES.ON_STUDENT || loginData.data.userType === ROLES.OFF_STUDENT) {
                    if (
                        loginData.data.isProfileUpdated === false &&
                        loginData.data.isReveiwStatus === STATUS.INITIAL &&
                        loginData.data.isPaymentStatus === false &&
                        loginData.data.isRenewStatus === false &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UPDATE_STUDENT}`);
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.PENDING &&
                        loginData.data.isPaymentStatus === false &&
                        loginData.data.isRenewStatus === false &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UPDATE_STUDENT}`);
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.PENDING &&
                        loginData.data.isPaymentStatus === true &&
                        loginData.data.isRenewStatus === true
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
                    }
                    if (
                        loginData.data.isReveiwStatus === STATUS.INITIAL &&
                        loginData.data.isInitialReveiwStatus === STATUS.PENDING
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
                    }

                    if (
                        loginData.data.isRenewStatus === false &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true &&
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.APPROVED &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UPDATE_STUDENT}`);
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true &&
                        loginData.data.isReveiwStatus === STATUS.REJECTED &&
                        loginData.data.isPaymentStatus === true &&
                        loginData.data.isRenewStatus === true &&
                        loginData.data.isInitialReveiwStatus === STATUS.APPROVED
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UPDATE_STUDENT}`);
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.APPROVED &&
                        loginData.data.isPaymentStatus === false &&
                        loginData.data.isRenewStatus === false &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true
                    ) {
                        router.push(`/${ROUTE_STRING.PROFILE_UPDATE_STUDENT}`);
                    }

                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.APPROVED &&
                        loginData.data.isPaymentStatus === true &&
                        loginData.data.isRenewStatus === true &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true
                    ) {
                        sessionStorage.setItem("isAllAuthentical", true);
                        getCurrentDateTime();
                        // router.push(`/${ROUTE_STRING.DASHBOARD}`);
                        if (currentRoute) {
                            router.push(currentRoute);
                        } else {
                            router.push(`/${ROUTE_STRING.DASHBOARD}`);
                        }
                    }
                }

                if (loginData.data.userType === ROLES.BLOG_MANAGEMENT) {
                    if (
                        loginData.data.isProfileUpdated === true &&
                        loginData.data.isReveiwStatus === STATUS.APPROVED &&
                        loginData.data.isPaymentStatus === true &&
                        loginData.data.isRenewStatus === true &&
                        loginData.data.isEmailVerifed === true &&
                        loginData.data.isMobileVerifed === true
                    ) {
                        router.push(`/${ROUTE_STRING.BLOGS}`);
                        getCurrentDateTime();
                    }
                }
            }
        }
        if (AllAuthentical) {
            getCurrentDateTime();
        }
    }, [currentRoute, router]);


    // useEffect(() => {
    //     const tokenData = sessionStorage.getItem("loginData");
    //     const loginData = JSON.parse(tokenData);
    //     let storePrevousRedirectUrl = sessionStorage.setItem("previousUrl", currentRoute);
    //     const AllAuthentical = localStorage.getItem("isAllAuthentical")
    //     //   setData({previousUrl:currentRoute})
    //     console.log("AllAuthentical", AllAuthentical);

    //     getCurrentDateTime();


    //     if (!tokenData) {
    //         router.push('/');
    //     }
    //     else {
    //         if (!AllAuthentical) {
    //             if (loginData.data.userType === ROLES.INTERVIEWER) {
    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.APPROVED &&
    //                     loginData.data.isPaymentStatus === true &&
    //                     loginData.data.isRenewStatus === true &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true
    //                 ) {
    //                     localStorage.setItem("isAllAuthentical", true);
    //                     router.push(`/${ROUTE_STRING.DASHBOARD}`);
    //                 }
    //             }
    //             if (loginData.data.userType === ROLES.CAMPUS) {
    //                 if (
    //                     loginData.data.isProfileUpdated === false &&
    //                     loginData.data.isReveiwStatus === STATUS.INITIAL &&
    //                     loginData.data.isPaymentStatus === false &&
    //                     loginData.data.isRenewStatus === false &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UPDATE_CAMPUS}`);
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.PENDING &&
    //                     loginData.data.isPaymentStatus === false &&
    //                     loginData.data.isRenewStatus === false &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UPDATE_CAMPUS}`);
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.PENDING &&
    //                     loginData.data.isPaymentStatus === true &&
    //                     loginData.data.isRenewStatus === true
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
    //                 }
    //                 if (
    //                     loginData.data.isReveiwStatus === STATUS.INITIAL &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.PENDING
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
    //                 }
    //                 if (
    //                     loginData.data.isRenewStatus === false &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true &&
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.APPROVED &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UPDATE_CAMPUS}`);
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true &&
    //                     loginData.data.isReveiwStatus === STATUS.REJECTED &&
    //                     loginData.data.isPaymentStatus === true &&
    //                     loginData.data.isRenewStatus === true &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UPDATE_CAMPUS}`);
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.APPROVED &&
    //                     loginData.data.isPaymentStatus === true &&
    //                     loginData.data.isRenewStatus === true &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true
    //                 ) {
    //                     localStorage.setItem("isAllAuthentical", true);
    //                     router.push(`/${ROUTE_STRING.DASHBOARD}`);
    //                 }
    //             }

    //             if (loginData.data.userType === ROLES.CORPORATE) {
    //                 if (
    //                     loginData.data.isProfileUpdated === false &&
    //                     loginData.data.isReveiwStatus === STATUS.INITIAL &&
    //                     loginData.data.isPaymentStatus === false &&
    //                     loginData.data.isRenewStatus === false &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push("/corporates/corporateprofileupdate");
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.PENDING &&
    //                     loginData.data.isPaymentStatus === false &&
    //                     loginData.data.isRenewStatus === false &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push("/corporates/corporateprofileupdate");
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.PENDING &&
    //                     loginData.data.isPaymentStatus === true &&
    //                     loginData.data.isRenewStatus === true
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
    //                 }
    //                 if (
    //                     loginData.data.isReveiwStatus === STATUS.INITIAL &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.PENDING
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
    //                 }
    //                 if (
    //                     loginData.data.isRenewStatus === false &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true &&
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.APPROVED &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push("/corporates/corporateprofileupdate");
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true &&
    //                     loginData.data.isReveiwStatus === STATUS.REJECTED &&
    //                     loginData.data.isPaymentStatus === true &&
    //                     loginData.data.isRenewStatus === true &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push("/corporates/corporateprofileupdate");
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.APPROVED &&
    //                     loginData.data.isPaymentStatus === true &&
    //                     loginData.data.isRenewStatus === true &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true
    //                 ) {
    //                     localStorage.setItem("isAllAuthentical", true);
    //                     router.push(`/${ROUTE_STRING.DASHBOARD}`);
    //                 }
    //             }

    //             if (loginData.data.userType === ROLES.ON_STUDENT || loginData.data.userType === ROLES.OFF_STUDENT) {
    //                 if (
    //                     loginData.data.isProfileUpdated === false &&
    //                     loginData.data.isReveiwStatus === STATUS.INITIAL &&
    //                     loginData.data.isPaymentStatus === false &&
    //                     loginData.data.isRenewStatus === false &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UPDATE_STUDENT}`);
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.PENDING &&
    //                     loginData.data.isPaymentStatus === false &&
    //                     loginData.data.isRenewStatus === false &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UPDATE_STUDENT}`);
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.PENDING &&
    //                     loginData.data.isPaymentStatus === true &&
    //                     loginData.data.isRenewStatus === true
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
    //                 }
    //                 if (
    //                     loginData.data.isReveiwStatus === STATUS.INITIAL &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.PENDING
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UNDER_REVIEW}`);
    //                 }

    //                 if (
    //                     loginData.data.isRenewStatus === false &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true &&
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.APPROVED &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UPDATE_STUDENT}`);
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true &&
    //                     loginData.data.isReveiwStatus === STATUS.REJECTED &&
    //                     loginData.data.isPaymentStatus === true &&
    //                     loginData.data.isRenewStatus === true &&
    //                     loginData.data.isInitialReveiwStatus === STATUS.APPROVED
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UPDATE_STUDENT}`);
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.APPROVED &&
    //                     loginData.data.isPaymentStatus === false &&
    //                     loginData.data.isRenewStatus === false &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.PROFILE_UPDATE_STUDENT}`);
    //                 }

    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.APPROVED &&
    //                     loginData.data.isPaymentStatus === true &&
    //                     loginData.data.isRenewStatus === true &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true
    //                 ) {
    //                     localStorage.setItem("isAllAuthentical", true);
    //                     router.push(`/${ROUTE_STRING.DASHBOARD}`);
    //                 }
    //             }

    //             if (loginData.data.userType === ROLES.BLOG_MANAGEMENT) {
    //                 if (
    //                     loginData.data.isProfileUpdated === true &&
    //                     loginData.data.isReveiwStatus === STATUS.APPROVED &&
    //                     loginData.data.isPaymentStatus === true &&
    //                     loginData.data.isRenewStatus === true &&
    //                     loginData.data.isEmailVerifed === true &&
    //                     loginData.data.isMobileVerifed === true
    //                 ) {
    //                     router.push(`/${ROUTE_STRING.BLOGS}`);
    //                 }
    //             }
    //         }
    //     }
    // }, [router]);
    const getCurrentDateTime = async () => {
        try {
            const response = await getCurrentDateTimeApi();
            if (response.data.hasError === false) {
                const backendTimestamp = response.data.data.timeStamp; // Backend timestamp
                const frontendTimestamp = moment().unix(); // Frontend timestamp

                console.log("Backend timestamp:", backendTimestamp);
                console.log("Frontend timestamp:", frontendTimestamp);

                // Check if the absolute difference is within 30 seconds
                const timeDifference = Math.abs(backendTimestamp - frontendTimestamp);
                const isWithinTolerance = timeDifference <= 15;

                if (isWithinTolerance) {
                    setIsDateTimeValidate(true);
                    console.log("Time is synchronized.");
                } else {
                    setIsDateTimeValidate(false);
                    alert(
                        "Please update your device time. Open Settings > Date & Time, and enable automatic synchronization or update the time manually."
                    );

                }
            }
        } catch (error) {
            console.error("Error fetching timestamp:", error);
            // Optionally, show a user-friendly error message
            //alert("An error occurred while validating the timestamp. Please try again.");
        }
    };

    if (isNotFound) {
        return <NotFoundPage />;
    }
    return <>{children}</>;
}

export default Auth;
